import { resetStateHelper, setCarteiraID, setParams, setData, setDataPersonalizada } from './preferenceSlice';
export const resetStateBuilder = (builder, initialState, dontChangeParameters, hardResetCarteira) => ({
    setParams: builder.addCase(setParams, (state) => {
        const newState = Object.assign({}, initialState);
        if (dontChangeParameters)
            for (const prop of dontChangeParameters)
                newState[prop] = state[prop];
        return newState;
    }),
    data: builder.addCase(setData, (state) => {
        const newState = Object.assign({}, initialState);
        if (dontChangeParameters)
            for (const prop of dontChangeParameters)
                newState[prop] = state[prop];
        return newState;
    }),
    carteiraID: builder.addCase(setCarteiraID, (state) => {
        const newState = Object.assign({}, initialState);
        if (dontChangeParameters && !hardResetCarteira)
            for (const prop of dontChangeParameters)
                newState[prop] = state[prop];
        return newState;
    }),
    dataPersonalizada: builder.addCase(setDataPersonalizada, (state) => {
        const newState = Object.assign({}, initialState);
        if (dontChangeParameters)
            for (const prop of dontChangeParameters)
                newState[prop] = state[prop];
        return newState;
    }),
    reset: builder.addCase(resetStateHelper, (state) => {
        const newState = Object.assign({}, initialState);
        if (dontChangeParameters)
            for (const prop of dontChangeParameters)
                newState[prop] = state[prop];
        return newState;
    }),
});
